import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#FFF" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0012 3L13.0012 5L11.4766 6.52533L9.47656 4.52533L11.0012 3Z"
        fill="#4C5965"
      />
      <path
        d="M3 10.9915V12.9915H5L10.5327 7.4668L8.53267 5.4668L3 10.9915Z"
        fill="#4C5965"
      />
    </svg>
  );
};

export default memo(Icon);
